export default __webpack_public_path__ + "static/media/MongoDB-Logo.153b7b44.svg";